import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import Link from 'next/link';
import { EditorRenderer } from '@hexx/renderer';
import { rendererBlockMaps } from 'src/lib/hexx/render-blocks';
import { Avatar } from 'src/components/avatar';
import is from 'is_js';
import { imageOptimize } from 'src/service/image';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  reppl: any;
}

function Guidelines(props: Props) {
  const { reppl, isOpen, onClose } = props;

  let output = reppl['guidelines'].blocks;
  let draft = false;
  if (is.empty(reppl['guidelines'])) {
    if (reppl['isOwner'] && !is.empty(reppl['guidelinesDraft'])) {
      output = reppl['guidelinesDraft'].blocks;
      draft = true;
    }
  }
  return (
    <Modal size="2xl" autoFocus={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay>
        <ModalContent
          layerStyle="layer3"
          maxWidth="720px"
          h={{ base: '100%', md: 'auto' }}
          mt={{ base: 0, md: '3.75rem' }}
        >
          <div className="guidelines">
            <div className="cover-image-box text-white reppl-banner relative bg-gray-300 Reppl-wrap pt-10 bg-blend-mode">
              <div className="w-container m-auto h-full">
                <div className="text-white font-sm mr-4 mb-1 flex items-center justify-center">
                  <Avatar
                    src={imageOptimize({
                      url: reppl['avatarImgURL'],
                      imgContainer: 'avatar',
                    })}
                    name={reppl['title']}
                    isLoading={!reppl['title']}
                    width={30}
                    height={30}
                    className="inline-block align-bottom mx-2"
                  />
                  <span className="font-bold text-sm ml-2">
                    {reppl['title']}
                  </span>
                </div>
                <div className="font-bold text-lg text-center">
                  {reppl['headline']}
                </div>
              </div>
            </div>
            <div className="bg-white px-20 py-16 relative">
              {reppl['isOwner'] && !draft && (
                <Link href={`/reppl/${reppl['id']}/about/edit_rule`}>
                  <a className="rules-and-guidelines-edit-button text-denim-500 border-gray-300 py-1 px-4 text-sm font-semibold rounded absolute right-8 top-8 border">
                    Edit
                  </a>
                </Link>
              )}
              <ul className="text-gray-500">
                <li className="mb-8">
                  <header className="font-semibold mb-2">Be kind</header>
                  <p className="font-sm">
                    Insulting, using foul language, spreading hate or bullying
                    other people will get your content removed or get you banned
                    from the RE:PPL without prior warning. Be authentic,
                    constructive and respect everyone&apos;s privacy.
                  </p>
                </li>
                <li className="mb-8">
                  <header className="font-semibold mb-2">
                    Don&apos;t advertise or spam
                  </header>
                  <p className="font-sm">
                    Don&apos;t use the RE:PPL to advertise yours or someone
                    else&apos;s activities or products
                  </p>
                </li>
              </ul>
              {reppl['isOwner'] && draft && (
                <div className="w-full left-0 absolute bottom-0 drfat-overlay h-3/5 z-10">
                  <div className="text-center mx-auto pt-20">
                    <p className="mb-4">Complete the previous edit</p>
                    <Link href={`/reppl/${reppl['id']}/about/edit_rule`}>
                      <a className="text-denim-500 border-gray-300 py-1 px-4 text-sm font-semibold rounded border">
                        Continue editing
                      </a>
                    </Link>
                  </div>
                </div>
              )}

              {!draft && (
                <div className="guidelines text-gray-500">
                  <EditorRenderer
                    maxWidth="100%"
                    blocks={output}
                    blockMap={rendererBlockMaps}
                  />
                </div>
              )}
            </div>
            <style jsx global>
              {`
                .cover-image-box {
                  background-image: url('${imageOptimize({
                    url: reppl?.coverImgURL,
                    imgContainer: 'projectCover',
                  })}');
                  background-size: cover;
                  background-repeat: no-repeat;
                  background-position: center center;
                }
                .rules-and-guidelines-edit-button {
                  display: none;
                }
                @media (min-width: 768px) {
                  .rules-and-guidelines-edit-button {
                    display: block;
                  }
                }
              `}
            </style>
          </div>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
}
export default Guidelines;
